var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReimbursementsBlocks = function SvgReimbursementsBlocks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 49,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5AC16F",
    stroke: "#429D54",
    d: "M47.392 5.021h81.891v2.014H47.392zM47.392 2.761h81.891v2.014H47.392zM47.392.5h81.891v2.014H47.392zM47.392 7.282h81.891v2.014H47.392zM47.392 9.543h81.891v2.014H47.392zM47.392 11.803h81.891v2.014H47.392zM47.392 14.064h81.891v2.014H47.392zM47.392 16.325h81.891v2.014H47.392zM47.392 18.585h81.891v2.014H47.392zM47.392 20.846h81.891v2.014H47.392zM47.392 23.107h81.891v2.014H47.392zM47.392 25.367h81.891v2.014H47.392zM47.392 27.628h81.891v2.014H47.392zM47.392 29.889h81.891v2.014H47.392zM47.392 32.15h81.891v2.014H47.392zM47.392 34.41h81.891v2.014H47.392zM47.392 36.671h81.891v2.014H47.392zM47.392 38.932h81.891v2.014H47.392zM47.392 41.192h81.891v2.014H47.392zM47.392 43.453h81.891v2.014H47.392zM47.392 45.714h81.891v2.014H47.392z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#46A459",
    d: "M77.787 0h21.1v48.228h-21.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#276433",
    fillOpacity: 0.5,
    d: "m82.783 21 14 13.897 14 13.103h-28z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#5AC16F",
    d: "M.5 20.846h81.891v2.014H.5zM.5 23.107h81.891v2.014H.5zM.5 25.368h81.891v2.014H.5zM.5 27.628h81.891v2.014H.5zM.5 29.889h81.891v2.014H.5zM.5 32.15h81.891v2.014H.5zM.5 34.41h81.891v2.014H.5zM.5 36.671h81.891v2.014H.5zM.5 38.932h81.891v2.014H.5zM.5 41.192h81.891v2.014H.5zM.5 43.453h81.891v2.014H.5zM.5 45.714h81.891v2.014H.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#5AC16F",
    d: "M30.896 20.346h21.1v27.882h-21.1z"
  })));
};
export default SvgReimbursementsBlocks;